import type { SupportChat } from '../models/SupportChat'
import useOctadeskChatStore from '../stores/useOctadeskChatStore'
import { OCTADESK_SCRIPT_ID, OCTADESK_SCRIPT_SRC } from '../constants/octadeskConstants'
import {
  applyOctadeskPointerEvents,
  startWatchingOctadeskPanelVisibility,
  stopWatchingOctadeskPanelVisibility
} from './useOctadeskDomLayout'

export function hasOctadeskScript (): boolean {
  return Boolean(document.getElementById(OCTADESK_SCRIPT_ID))
}

export function injectOctadeskScript (data: SupportChat): void {
  if (!data.isSupportActive || !data.supportSubdomain) {
    return
  }

  if (hasOctadeskScript()) {
    startWatchingOctadeskPanelVisibility()
    return
  }

  window.octadesk = window.octadesk || {}
  window.octadesk.chatOptions = {
    subDomain: data.supportSubdomain,
    showButton: 'false',
    openOnMessage: 'true',
    showFooterPoweredBy: 'true',
    hide: 'false',
    ...(data.user ? { login: data.user } : {})
  }

  const script = document.createElement('script')
  script.id = OCTADESK_SCRIPT_ID
  script.async = true
  script.src = OCTADESK_SCRIPT_SRC
  script.onload = (): void => {
    startWatchingOctadeskPanelVisibility()
    applyOctadeskPointerEvents()
  }
  script.onerror = (): void => {
    script.remove()
    if (window.octadesk) {
      delete window.octadesk
    }
    stopWatchingOctadeskPanelVisibility()
    useOctadeskChatStore().reset()
  }
  document.body.appendChild(script)
}

export function removeOctadeskScript (): void {
  stopWatchingOctadeskPanelVisibility()
  useOctadeskChatStore().reset()

  const script = document.getElementById(OCTADESK_SCRIPT_ID)
  if (script) {
    script.remove()
  }

  if (window.octadesk) {
    delete window.octadesk
  }

  document.querySelectorAll('.octadesk-octachat-app, [id^="octadesk"]').forEach(el => el.remove())
}
